import dayjs from 'dayjs';
import {DATE_FORMAT} from '../../shared/utils/date';
import {store} from '../store';
import {selectSelectedDate} from '../store/slices/selectors';

export const countDaysFromCurrentDate = () => {
  const state = store.getState();
  const selectedDate = selectSelectedDate(state);
  const today = dayjs(new Date()).format(DATE_FORMAT);
  const daysFromCurrentDate = dayjs(selectedDate).diff(today, 'day');
  return daysFromCurrentDate;
};
